(() => {
  const roots = document.querySelectorAll('[data-ll-about-timeline]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const medias = [...root.querySelectorAll('[data-ll-timeline-media]')];
    const copies = [...root.querySelectorAll('[data-ll-timeline-copy]')];
    const tabs = [...root.querySelectorAll('[data-ll-timeline-tab]')];
    const progress = root.querySelector('[data-ll-timeline-progress]');
    const prevBtn = root.querySelector('[data-ll-timeline-prev]');
    const nextBtn = root.querySelector('[data-ll-timeline-next]');
    const total = Math.max(medias.length, copies.length, tabs.length);
    if (!total) return;

    let index = Math.max(
      0,
      tabs.findIndex((tab) => tab.classList.contains('is-active'))
    );

    const setActive = (nextIndex) => {
      index = ((nextIndex % total) + total) % total;

      medias.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
      });

      copies.forEach((el, i) => {
        const on = i === index;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      tabs.forEach((tab, i) => {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });

      if (progress) {
        // Cumulative pink fill through the active year (1/3, 2/3, 3/3)
        progress.style.width = `${((index + 1) / total) * 100}%`;
      }

      root.dataset.llTimelineIndex = String(index);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabIndex = Number(tab.getAttribute('data-ll-timeline-index'));
        if (Number.isNaN(tabIndex)) return;
        setActive(tabIndex);
      });
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const next = e.key === 'ArrowRight' ? index + 1 : index - 1;
        setActive(next);
        tabs[index]?.focus();
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => setActive(index - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => setActive(index + 1));

    setActive(index);
  });
})();
